@if (label) {
  <span class="label">{{ label }}</span>
}
@if (loading) {
  <mat-spinner class="spinner" diameter="16" />
} @else {
  <a mat-button class="link-button" [attr.href]="href ?? null" [disabled]="disabled" (click)="onClick($event)">
    {{ text }}
    @if (trailingIcon) {
      <mat-icon iconPositionEnd>{{ trailingIcon }}</mat-icon>
    }
  </a>
}
